<template>
  <div>
    <div v-if="savedLocations.length > 0">
      <GmapMap
        ref="mapRef"
        :key="index"
        v-for="(l, index) in savedLocations"
        :center="{ lat: l.geoPoint.latitude, lng: l.geoPoint.longitude }"
        :zoom="18"
        :clickable="true"
        :draggable="false"
        :options="mapOptions"
        map-type-id="roadmap"
        style="width: 100%; height: 450px; margin-top: 60px"
      >
        <GmapMarker
          :key="index"
          :clickable="false"
          :draggable="false"
          :options="mapOptions"
          v-for="(l, index) in savedLocations"
          :position="{ lat: l.geoPoint.latitude, lng: l.geoPoint.longitude }"
        />
      </GmapMap>
    </div>
  </div>
</template>
<script>

import axios from "axios";

export default {
  name: "GoogleMaps",
  props: {
    street: String,
    city: String,
    state: String,
    zip: String,
    pais: String,
    coordinates: {}
  },
  data: () => ({
    savedLocations: [],
    formData: {
      street: "",
      city: "",
      state: "",
      zip: "",
      pais: ""
    },
    mapOptions: {
        disableDefaultUI: true,
      },
  }),
  
  created() {
    
  },

  methods: {
    setPosition(latitud, longitud) {
      if(latitud && longitud) {
        let obj = {
          geoPoint: {
            latitude: latitud,
            longitude: longitud,
          }
        }
        this.pushToSavedLocation(obj)
      }
    },
    async handleFormSubmit() {
      this.formData.street = this.street;
      this.formData.city = this.city;
      this.formData.state = this.state;
      this.formData.zip = this.zip;
      this.formData.pais = this.pais;

      if (
        !this.formData.street ||
        !this.formData.city ||
        !this.formData.state ||
        !this.formData.zip ||
        !this.formData.pais
      ) {
        /*  alert("se deben completar todos los campos!");
        return; */
      }

      //Make request
      //const googleMapsApiKey = "AIzaSyAzaRnAxSF8hxFNvOglaPf1nLXFBANYngM";//
      const googleMapsApiKey = "AIzaSyAHaL0Gi8Pj7mCUCJ2RPk9VZQLKM0GAUls";//
      
      let address = `${this.formData.street}, ${this.formData.city}, ${this.formData.state} ${this.formData.zip}, ${this.formData.pais}`;

         let { data } = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${googleMapsApiKey}`,
          {
            data: address,
          }
        );
      
      if (data === "No Results") {
        alert("No se econtro la direccion");
        return;
      }

      //massage data to fit our schema
      let obj = {
        address: data.results[0],
        geoPoint: {
          latitude: data.results[0].geometry.location.lat,
          longitude: data.results[0].geometry.location.lng,
        },
      };
      this.$parent.form.latitud = data.results[0].geometry.location.lat;
      this.$parent.form.longitud = data.results[0].geometry.location.lng;
      data.results[0].address_components.forEach(adressComponent => {
        let type = adressComponent.types.find(type => type == "locality" || type == "sublocality")
        if(type) {
          console.log("ciudad: " + adressComponent.long_name);
          this.$parent.form.ciudad = adressComponent.long_name
        }
        type = adressComponent.types.find(type => type == "administrative_area_level_1")
        if(type) {
          console.log("provincia: " + adressComponent.long_name);
          this.$parent.form.provincia = adressComponent.long_name
        }
        type = adressComponent.types.find(type => type == "country")
        if(type) {
          console.log("pais: " + adressComponent.long_name);
          this.$parent.form.pais = adressComponent.long_name
        }
      });

      
      //add to saved locations to update map
      this.pushToSavedLocation(obj);

      console.log(data);
      //clear form
      this.formData.street = "";
      this.formData.city = "";
      this.formData.state = "";
      this.formData.zip = "";
    },
    pushToSavedLocation(obj) {
      if (this.savedLocations.length > 0) {
        this.savedLocations.splice(0, 1);
        this.savedLocations.push(obj);
      } else {
        this.savedLocations.push(obj);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>